/* <contact-form> — iletişim formu istemci doğrulaması (aria-invalid + aria-describedby hata metni),
   hata özeti, mesaj sayacı, gönderiliyor durumu. Kurallar: [data-rule] = name | email | phone | required | min10 | consent */
class ContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.noValidate = true;
    this.fields = Array.from(this.form.querySelectorAll('[data-rule]'));
    this.summary = this.querySelector('[data-error-summary]');
    this.counter = this.querySelector('[data-counter]');
    this.message = this.form.querySelector('textarea[maxlength]');

    this.form.addEventListener('submit', (e) => {
      this.tried = true;
      const invalid = this.validate();
      if (invalid.length) {
        e.preventDefault();
        invalid[0].focus();
        return;
      }
      const btn = this.form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      }
    });
    this.form.addEventListener('input', () => this.tried && this.validate());
    this.form.addEventListener('change', () => this.tried && this.validate());

    if (this.message && this.counter) {
      const sync = () => (this.counter.textContent = `${this.message.value.length}/${this.message.maxLength}`);
      this.message.addEventListener('input', sync);
      sync();
    }
  }

  check(field) {
    const v = field.type === 'checkbox' ? field.checked : field.value.trim();
    switch (field.dataset.rule) {
      case 'name':
        if (v.length < 2) return 'blank';
        return v.split(/\s+/).length < 2 ? 'surname' : '';
      case 'email':
        if (!v) return 'blank';
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v) ? '' : 'invalid';
      case 'phone':
        if (!v && !field.required) return '';
        return v.replace(/\D/g, '').length < 10 ? 'invalid' : '';
      case 'min10':
        return v.length < 10 ? 'blank' : '';
      case 'consent':
        return v ? '' : 'blank';
      default:
        return v ? '' : 'blank';
    }
  }

  validate() {
    const invalid = [];
    this.fields.forEach((field) => {
      const key = this.check(field);
      const error = document.getElementById(field.dataset.errorId);
      const on = !!key;
      if (on) {
        invalid.push(field);
        field.setAttribute('aria-invalid', 'true');
      } else {
        field.removeAttribute('aria-invalid');
      }
      if (error) {
        error.hidden = !on;
        const text = error.querySelector('[data-error-text]');
        if (text && on) text.textContent = field.dataset[`msg${key.charAt(0).toUpperCase()}${key.slice(1)}`] || '';
      }
    });
    if (this.summary) {
      this.summary.hidden = !invalid.length;
      const text = this.summary.querySelector('[data-error-text]');
      if (text) text.textContent = (this.summary.dataset.template || '').replace('[count]', invalid.length);
    }
    return invalid;
  }
}
if (!customElements.get('contact-form')) customElements.define('contact-form', ContactForm);
